import { supabase } from './supabaseClient';

export interface StudentAssignment {
  assignment_id: number;
  concept_id: number;
  concept_name: string;
  title: string;
  description?: string;
  due_date: string;
  type: 'explore' | 'practice' | 'challenge';
  status: 'completed' | 'pending';
  score?: number;
  completed_at?: string;
}

export interface AssignmentContext {
  id: number;
  type: 'explore' | 'practice' | 'challenge';
  due_date: string;
  title: string;
}

/**
 * Get assignments for the current student
 */
export async function getStudentAssignments(studentId: string): Promise<StudentAssignment[]> {
  const { data, error } = await supabase.rpc('get_student_assignments', {
    p_student_id: studentId,
  });

  if (error) {
    console.error('Error fetching student assignments:', error);
    throw error;
  }

  return data || [];
}

/**
 * Mark an assignment as complete
 */
export async function markAssignmentComplete(
  assignmentId: number,
  studentId: string,
  score: number,
  questionsAttempted: number
): Promise<{ success: boolean }> {
  const { data, error } = await supabase.rpc('mark_assignment_complete', {
    p_assignment_id: assignmentId,
    p_student_id: studentId,
    p_score: score,
    p_questions_attempted: questionsAttempted,
  });

  if (error) {
    console.error('Error marking assignment complete:', error);
    throw error;
  }

  return data;
}

/**
 * Check if a concept is part of any pending assignment
 */
export async function checkConceptAssignment(
  studentId: string,
  conceptId: number
): Promise<StudentAssignment | null> {
  const assignments = await getStudentAssignments(studentId);
  return (
    assignments.find(
      (a) => a.concept_id === conceptId && a.status === 'pending'
    ) || null
  );
}
